import { render, staticRenderFns } from "./TelegramSignin.vue?vue&type=template&id=21bff1d9&scoped=true"
import script from "./TelegramSignin.vue?vue&type=script&lang=js"
export * from "./TelegramSignin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bff1d9",
  null
  
)

export default component.exports